import axios from "axios";
import { baseUrl } from "../constants/constant";
import { store } from "../app/store/store";
import { errorToast } from "../notification/notification";
import storage from "redux-persist/lib/storage";

const req = axios.create({
  baseURL: baseUrl,
});

const useApplicationJson = [
  "auth/register",
  "auth/login",
  "auth/verify-code",
  "auth/resend-code",
  "auth/update-password",
  "auth/reset-password",
  "profile/update",
  "address/store",
  "address/update",
  "favourite/store",
  "cart/store",
  "user/seller",
  "product",
  "product/category",
];

const useMultipart = ["user/upload", "product/image"];

const useAuthorization = [
  "user/upload",
  "user/seller",
  "user/seller/product",
  "cart",
  "favourite",
  "address",
  "profile",
  "product/image",
];

req.interceptors.request.use(
  (request) => {
    useApplicationJson.forEach((url) => {
      if (request.url.includes(url)) {
        request.headers.common["Content-Type"] = "application/json";
      }
    });

    useMultipart.forEach((url) => {
      if (request.url.includes(url)) {
        request.headers.common["Content-Type"] = "multipart/form-data";
      }
    });

    useAuthorization.forEach((url) => {
      if (request.url.includes(url)) {
        request.headers.common["Authorization"] = `Bearer ${
          store.getState().user.user?.data?.accessToken
        }`;
      }
    });
    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);

req.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.message === "Network Error") errorToast(error.message);
    else if (error.response.data.statusCode === 401) {
      errorToast("Session Expired");
      storage.removeItem("persist:root");
      window.location.replace("/sign-in");
    } else errorToast(error.response.data.message);
    return Promise.reject(error);
  }
);

export default req;
